const sidebarReducer = (state, { type, payload }) => {
  switch (type) {
    case "SET_EXPANDED": {
      return { ...state, isExpanded: payload.isExpanded };
    }
    case "TOGGLE_SIDEBAR": {
      return { ...state, isExpanded: !state.isExpanded };
    }
    case "SET_CURRENT_APP": {
      return { ...state, currentApp: payload.currentApp };
    }
    default: {
      throw new Error(`Unhandled action type: ${type}`);
    }
  }
};

export default sidebarReducer;
